import React from "react"
import { Redirect } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import SetPassword from "../pages/Authentication/SetPassword"

// Communication
import Chat from "../pages/Chat/Chat"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

// Player
import PlayerAccounts from "../pages/UserAccounts/PlayerAccounts/index"
import EditPlayer from "../pages/UserAccounts/PlayerAccounts/editAccount"
import CreatePlayer from "../pages/UserAccounts/PlayerAccounts/createAccount"
import PlayerProfile from "../pages/UserAccounts/PlayerAccounts/UserProfile"

// Clubs
import ClubAccounts from "../pages/UserAccounts/ClubAccounts/index"
import EditClub from "../pages/UserAccounts/ClubAccounts/editClub"
import CreateClub from "../pages/UserAccounts/ClubAccounts/createClub"
import ClubProfile from "../pages/UserAccounts/ClubAccounts/ClubProfile"

// Organizers
import OrganizerAccounts from "../pages/UserAccounts/OrganizerAccounts/index"
import OrganizerProfile from "../pages/UserAccounts/OrganizerAccounts/ProfileInfo"

import ClubBusinessLeads from "../pages/UserAccounts/ClubBusinessLeads/index"
import ClubBusinessLeadsInfo from "../pages/UserAccounts/ClubBusinessLeads/clubLeadInfo"

// Admins
import AdminAccounts from "../pages/UserAccounts/PlatformAdmins/index"
import AdminProfile from "../pages/UserAccounts/PlatformAdmins/adminProfile"
import CreateAdmin from "../pages/UserAccounts/PlatformAdmins/createAdmin"
import EditAdmin from "../pages/UserAccounts/PlatformAdmins/editAdmin"
// PRD 14 I5 — Tenis10 Claims (the Tenis10 migration's support page)
import Tenis10Claims from "../pages/Tenis10Claims/index"
import Tenis10ClaimsFamily from "../pages/Tenis10Claims/FamilyPage"
import Tenis10ClaimsLog from "../pages/Tenis10Claims/ClaimsLog"

import EventsManagement from "../pages/EventsManagement/index"
import EventsPlanner from "../pages/EventsPlanner/index"
import GenerateProposals from "../pages/EventsPlanner/GenerateProposals"
import BookingsManagement from "../pages/BookingsManagement"
import PaymentsManagement from "../pages/PaymentsManagement/index"
import ExtendedAnalytics from "../pages/ExtendedAnalytics/index"
import PenaltiesManagement from "../pages/PenaltiesManagement/index"
import AddPenalty from "../pages/PenaltiesManagement/AddPenalty"
import ReportsManagement from "../pages/ReportsManagement"
import ReportDetails from "../pages/ReportsManagement/Details"
import PromoZones from "../pages/PromoZones/index"
import LeaderboardsManagement from "../pages/LeaderboardsManagement/index"
import SystemSettings from "../pages/SystemSettings/index"
import TournamentFeedback from "../pages/TournamentFeedback/index"
import Partners from "../pages/Partners/index"
import LogisticsProducts from "../pages/Logistics/Products/index"
import LogisticsEstimates from "../pages/Logistics/Estimates/index"
import LogisticsSheets from "../pages/Logistics/Sheets/index"
import LogisticsShipments from "../pages/Logistics/Shipments/index"
import LogisticsSettings from "../pages/Logistics/Settings/index"
import LogisticsStock from "../pages/Logistics/Stock/index"
import LogisticsWarehouse from "../pages/Logistics/Warehouse/index"
import Event from "pages/EventsManagement/components/Event"
import Competition from "../pages/EventsManagement/components/Tabs/Competitions/Competition"
import AddAnouncement from "../pages/EventsManagement/components/Tabs/Competitions/AddAnouncement"
import PhaseDetails from "../pages/EventsManagement/components/Tabs/Competitions/Tabs/Phases/Components/Details"
import PhasesDetails from "pages/EventsManagement/components/Tabs/Competitions/Tabs/Phases/Components"
import AddPenalties from "pages/EventsManagement/components/Tabs/Competitions/Tabs/Penalties/AddPenalties"
import FriendlyMatches from "pages/FriendlyMatches"
import FriendlyMatchDetails from "pages/FriendlyMatches/Details"
import BookingDetails from "../pages/BookingsManagement/components/BookingInfo";
import PageNotFound from "../pages/NotFound"
import MarketingNewsletters from "../pages/Marketing/Newsletters"

const userRoutes = [
  { path: "/dashboard", component: Dashboard },

  // players
  { path: "/accounts/players", component: PlayerAccounts },
  { path: "/accounts/players/create", component: CreatePlayer },
  { path: "/accounts/players/:id", component: PlayerProfile },
  { path: "/accounts/players/:id/edit", component: EditPlayer },

  // clubs
  { path: "/accounts/clubs", component: ClubAccounts },
  { path: "/accounts/clubs/create", component: CreateClub },
  { path: "/accounts/clubs/create/:id", component: CreateClub },
  { path: "/accounts/clubs/:id", component: ClubProfile },
  { path: "/accounts/clubs/:id/edit", component: EditClub },

  // clubs leads
  { path: "/accounts/clubs-leads", component: ClubBusinessLeads },
  { path: "/accounts/clubs-leads/:id", component: ClubBusinessLeadsInfo },

  // organizers
  { path: "/accounts/organizers", component: OrganizerAccounts },
  { path: "/accounts/organizers/:id", component: OrganizerProfile },

  // admins
  { path: "/accounts/admins", component: AdminAccounts },
  { path: "/accounts/admins/create", component: CreateAdmin },
  { path: "/accounts/admins/:id", component: AdminProfile },
  { path: "/accounts/admins/:id/edit", component: EditAdmin },

  // Tenis10 Claims (PRD 14 I5)
  { path: "/accounts/tenis10-claims", component: Tenis10Claims },
  { path: "/accounts/tenis10-claims/log", component: Tenis10ClaimsLog },
  { path: "/accounts/tenis10-claims/families/:invitationId", component: Tenis10ClaimsFamily },

  { path: "/events-management", component: EventsManagement },
  // The Events Planner (SuperAdmin only, cpAccessPolicy.js).
  { path: "/events-planner", component: EventsPlanner },
  { path: "/events-planner/generate", component: GenerateProposals },
  { path: "/events/:id?/:tab?", component: Event },

  // Phase details
  {
    path: "/events/:id?/competitions/:competitionId?/phases/:phaseId/:tab?",
    component: PhasesDetails,
  },
  {
    path: "/events/:id?/competitions/:competitionId?/add-phase",
    component: PhaseDetails,
  },
  {
    path: "/events/:id?/competitions/:competitionId?/add-penalties",
    component: AddPenalties,
  },
  {
    path: "/events/:id?/competitions/:competitionId?/:penaltyId?/add-penalties",
    component: AddPenalties,
  },

  // edit competition
  {
    path: "/events/:id?/competitions/:competitionId?/:tab?",
    component: Competition,
  },

  { path: "/add/:id?/competition", component: Competition },
  { path: "/add-announcement/:eventId?", component: AddAnouncement },
  {
    path: "/add-announcement/:eventId?/:announcementId?",
    component: AddAnouncement,
  },
  { path: "/bookings-management", component: BookingsManagement },
  { path: "/bookings/:id", component: BookingDetails },
  { path: "/payments-management", component: PaymentsManagement },
  { path: "/extended-analytics", component: ExtendedAnalytics },
  // P96 — Marketing → Newsletters (super admins: cpAccessPolicy)
  { path: "/marketing/newsletters", component: MarketingNewsletters },
  { path: "/penalties-management/add", component: AddPenalty },
  { path: "/penalties-management", component: PenaltiesManagement },
  { path: "/reports-management/:reportId", component: ReportDetails },
  { path: "/reports-management", component: ReportsManagement },
  { path: "/promo-zones", component: PromoZones },
  { path: "/rankings-management", component: LeaderboardsManagement },
  { path: "/system-settings", component: SystemSettings },
  // SuperAdmin only (cpAccessPolicy.js); Analysis is the default tab, any other tab is Page not found.
  { path: "/tournament-feedback/:tab(analysis|setup)?", component: TournamentFeedback },
  { path: "/settings/partners", component: Partners },
  // The global Logistics section (SuperAdmin only, cpAccessPolicy.js).
  { path: "/logistics", component: () => <Redirect to="/logistics/warehouse" /> },
  { path: "/logistics/warehouse", component: LogisticsWarehouse },
  { path: "/logistics/sheets", component: LogisticsSheets },
  { path: "/logistics/shipments", component: LogisticsShipments },
  { path: "/logistics/stock", component: LogisticsStock },
  { path: "/logistics/products", component: LogisticsProducts },
  { path: "/logistics/estimates", component: LogisticsEstimates },
  { path: "/logistics/settings", component: LogisticsSettings },
  { path: "/friendly-matches", component: FriendlyMatches },
  { path: "/friendly-matches/:id", component: FriendlyMatchDetails },

  //chat
  { path: "/chat/:id", component: Chat },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
  // Any other address: App.js renders these routes in a Switch, which takes the first route that matches.
  { path: "*", component: PageNotFound },
]

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/accounts/:id/set-password/:resetCode", component: SetPassword },
  // The same page with the code in the fragment (`#code=…`), which reaches neither the server nor a Referer. After the
  // route above: the Switch takes the first route that matches, and this one also matches the path above.
  { path: "/accounts/:id/set-password", component: SetPassword },
]

export { userRoutes, authRoutes }
